export const GROUP_PATH_SEPARATOR = '/'

export const countersTypeToParamKey = {
    record: '_countOfRecordsPerLevel',
    groupAndRecords: '_countOfGroupsAndRecordsPerLevel'
} as const

export const totalRowKey = 'total'
export const aggCellBgColorRgba = '119, 159, 233'
export const decreaseOpacityPerLevelPercent = 20
